import React, { useState, useEffect } from 'react';

// Dumaloq avatar: imageUrl bo'lsa rasm, yo'q yoki yuklanmasa — ism bosh harflari (sariq fon).
export function initialsOf(firstName, lastName) {
  const a = String(firstName || '').trim().charAt(0);
  const b = String(lastName || '').trim().charAt(0);
  return (a + b).toUpperCase() || '?';
}

export default function Avatar({ src, firstName, lastName, size = 40 }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => { setBroken(false); }, [src]);

  const box = {
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    flexShrink: 0,
    overflow: 'hidden',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--color-primary)',
    color: 'var(--color-on-primary)',
    fontWeight: '700',
    fontSize: `${Math.round(size * 0.4)}px`,
    fontFamily: 'var(--font-family)',
  };

  if (src && !broken) {
    return (
      <span style={box}>
        <img
          src={src}
          alt=""
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          onError={() => setBroken(true)}
        />
      </span>
    );
  }
  return <span style={box} aria-hidden="true">{initialsOf(firstName, lastName)}</span>;
}
